import type { MantineColorsTuple } from '@mantine/core';

const primary: MantineColorsTuple = [
  '#e6eaf2', // JIRA - lighter-blue
  '#e6e6e7',
  '#c8cbd0',
  '#a7aeb9',
  '#8c96a5',
  '#7b8799',
  '#717f95',
  '#5f6d82',
  '#8297b4', // JIRA - medium-blue
  '#323F4F', // JIRA - dark-blue
];

export const palette = {
  primary,
};
